import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFInvoices from './PDFInvoices';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        filename: '',
        invoice_total: 0,
        quotation_total: 0,
        invoice_remaining: 0,
        total: 0,
        max: 0,
        readOnly: false,
        invoiceRemaining: false,
        invoices: [],
        invoiceData: [],
        customers: [],
        quotations: [],
        quotationItems: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.invoices;
        state[e.target.name] = e.target.value;
        this.setState({ invoices: state, errors: [] });
    };
    changeTotalValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const paid_type = document.getElementById('paid_type').value;
        const invoice_id = document.getElementById('invoice_id').value;
        const invoice_date = document.getElementById('invoice_date').value;
        const invoice_total = document.getElementById('invoice_total').value;
        const invoice_status = document.getElementById('invoice_status').value;
        const details = document.getElementById('details').value;
        var errors = [];
        if (!paid_type) { errors.push("error_paid_type"); }
        if (!invoice_total) { errors.push("error_invoice_total"); }
        if (invoice_total === '0') { errors.push("error_invoice_total"); }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form_invoice');
        let formData = new FormData(form);
        try {
            Swal.fire({
                title: 'Updating...',
                text: 'Please, wait',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const invoicesDataRes = await authAxios.post("invoices/update", formData)
            if (!invoicesDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            const { ID_INVOICE } = invoicesDataRes.data;
            const dataAccountsReceivable = {
                invoice_id: invoice_id,
                invoice_date: invoice_date,
                invoice_total: invoice_total,
                invoice_status: invoice_status,
                details: details,
                customer_id: document.getElementById('customer_id').value,
                user_id: window.localStorage.getItem('idusuario'),
                id_invoice: ID_INVOICE
            }
            const accountsReceivable = await authAxios.post("accounts_receivable/update", dataAccountsReceivable);
            if (!accountsReceivable.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Invoices!',
                invoicesDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpInvoices/" + ID_INVOICE);
            const updatedData = await authAxios.get("invoices/view/" + ID_INVOICE)
            this.setState({
                invoices: updatedData.data.invoice,
                quotation_total: updatedData.data.quotation.TOTAL,
                invoice_remaining: updatedData.data.quotation.TOTAL - updatedData.data.invoice.INVOICE_TOTAL,
                readOnly: updatedData.data.invoice.PAID_TYPE === 2 ? false : true,
                invoiceRemaining: updatedData.data.invoice.PAID_TYPE === 2 ? true : false,
                total: updatedData.data.total,
                max: updatedData.data.total,
                customers: updatedData.data.customer,
                quotations: updatedData.data.quotation,
                quotationItems: updatedData.data.items,
                load: ''
            });
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    previewPDFInvoices = (id_invoice) => {
        authAxios.get(`invoices/generate_invoice/${id_invoice}`)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }         
                const filename = `TC Transport - Invoice #${dataResult.data.invoice.ID_INVOICE}.pdf`
                this.setState({
                    invoiceData: dataResult.data,
                    filename: filename
                });
            })
            .catch((error) => console.log(error))
    }
    calculateTotal = (e) => {
        switch (e.target.value) {
            case '2':
                this.setState((prevState) => ({
                    invoices: {
                        ...prevState.invoices,
                        INVOICE_TOTAL: 0,
                        INVOICE_REMAINING: 0,
                    },
                    invoice_total: 0,
                    invoice_remaining: 0,
                    readOnly: false,
                    invoiceRemaining: true,
                }));
                break;
            case '3':
                this.setState((prevState) => ({
                    invoices: {
                        ...prevState.invoices,
                        INVOICE_TOTAL: this.state.quotation_total,
                        INVOICE_REMAINING: 0,
                    },
                    invoice_total: this.state.quotation_total,
                    invoice_remaining: 0,
                    readOnly: true,
                    invoiceRemaining: false,
                }));
                break;
        }
    }
    calculateRemaining = (e) => {
        const invoice_total = parseFloat(e.target.value) || 0;
        const { quotation_total } = this.state || 0;
        this.setState((prevState) => ({
            invoice_remaining: quotation_total - invoice_total,
            invoices: {
                ...prevState.invoices,
                INVOICE_TOTAL: invoice_total,
                INVOICE_REMAINING: quotation_total - invoice_total
            }
        }));
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("invoices/view/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                this.setState({
                    invoices: dataResult.data.invoice,
                    quotation_total: dataResult.data.quotation.TOTAL,
                    invoice_remaining: dataResult.data.quotation.TOTAL - dataResult.data.invoice.INVOICE_TOTAL,
                    readOnly: dataResult.data.invoice.PAID_TYPE === 2 ? false : true,
                    invoiceRemaining: dataResult.data.invoice.PAID_TYPE === 2 ? true : false,
                    total: dataResult.data.total,
                    max: dataResult.data.total,
                    customers: dataResult.data.customer,
                    quotations: dataResult.data.quotation,
                    quotationItems: dataResult.data.items,
                    load: ''
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, filename, quotation_total, invoice_remaining, max, readOnly, invoiceRemaining, invoices, invoiceData, customers, quotations, quotationItems } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {
                                    load ?
                                        (<b>{load}</b>)
                                    :
                                        (<b>UPDATE INVOICE</b>)
                                }
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form_invoice">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="row g-3">
                                                <div className="col-md-12 text-right">
                                                    <button type="button" className="btn btn-secondary btn-sm" data-bs-toggle='modal' data-bs-target="#PDFInvoicesModal" slot='end'
                                                        onClick={() => {
                                                            this.previewPDFInvoices(invoices.ID_INVOICE)
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Print Invoice
                                                    </button>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INVOICE INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_invoice" value={this.props.match.params.id} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="invoice_id">Invoice ID.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="invoice_id" id="invoice_id" defaultValue={invoices.ID_INVOICE}
                                                            className="form-control form-control-sm" placeholder="Quotation ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_date">Invoice Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="invoice_date" id="invoice_date" defaultValue={invoices.INVOICE_DATE}
                                                            className="form-control form-control-sm" placeholder="Due Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="invoice_status">Status</label>
                                                    <input type="text" name="invoice_status" id="invoice_status"
                                                        defaultValue={
                                                            invoices.STATUS === 1 ? "IN PROCESS" :
                                                            invoices.STATUS === 2 ? "PARTIAL PAID" :
                                                            invoices.STATUS === 3 ? "TOTAL PAID" : ""
                                                        }
                                                        style={{
                                                            textTransform: 'uppercase',
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            backgroundColor:
                                                                invoices.STATUS === 1 ? "#00539B" :
                                                                invoices.STATUS === 2 ? "#20C997" :
                                                                invoices.STATUS === 3 ? "#198754" : ""
                                                        }}
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="details" name="details" rows='3' defaultValue={invoices.DETAILS}
                                                        className='form-control form-control-sm' onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>CUSTOMER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="customer_id">Customer ID.</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_id" id="customer_id" defaultValue={customers.ID_CUSTOMER} 
                                                        className="form-control form-control-sm" placeholder="Customer ID." aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_name">Customer Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_name" id="customer_name" defaultValue={customers.NAME} 
                                                        className="form-control form-control-sm" placeholder="Customer Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_address">Customer Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_address" id="customer_address" defaultValue={customers.ADDRESS} 
                                                        className="form-control form-control-sm" placeholder="Customer Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="customer_phone">Customer Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_phone" id="customer_phone" defaultValue={customers.PHONE} 
                                                            className="form-control form-control-sm" placeholder="Customer Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Customer Phone</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>QUOTATION INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="quotation_id">Quotation ID.</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="quotation_id" id="quotation_id" defaultValue={quotations.ID_QUOTATION} 
                                                        className="form-control form-control-sm" placeholder="Quotation ID." aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="quotation_date">Quotation Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="quotation_date" id="quotation_date" defaultValue={quotations.QUOTATION_DATE}
                                                            className="form-control form-control-sm" placeholder="Quotation Date" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="due_date">Due Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="due_date" id="due_date" defaultValue={quotations.DUE_DATE}
                                                            className="form-control form-control-sm" placeholder="Due Date" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="quotation_status">Status</label>
                                                    <input type="text" name="quotation_status" id="quotation_status"
                                                        defaultValue={
                                                            quotations.STATUS === 1 ? "IN PROCESS" :
                                                            quotations.STATUS === 2 ? "APPROVED" :
                                                            quotations.STATUS === 3 ? "CANCELED" : ""
                                                        }
                                                        style={{
                                                            textTransform: 'uppercase',
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            backgroundColor:
                                                                quotations.STATUS === 1 ? "#00539B" :
                                                                quotations.STATUS === 2 ? "#198754" :
                                                                quotations.STATUS === 3 ? "#DC3545" : ""
                                                        }}
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="quotation_details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }}
                                                        className='form-control form-control-sm' id="quotation_details" name="quotation_details" rows='3' defaultValue={quotations.DETAILS}
                                                        onChange={this.changeValue} aria-describedby="helpId" readOnly></textarea>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row g-3'>
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">DESCRIPTION</th>
                                                                <th className="align-middle">HUD #</th>
                                                                <th className="align-middle">AMOUNT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                quotationItems.map((itemArrayResult) => (
                                                                    <tr key={itemArrayResult.ID_QUOT_ITEM}>
                                                                        <td>{itemArrayResult.DESCRIPTION}</td>
                                                                        <td>{itemArrayResult.HUD_NUMBER}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemArrayResult.AMOUNT)}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>PAYMENT INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="sub_total">Sub Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="sub_total" id="sub_total" defaultValue={quotations.SUB_TOTAL}
                                                            className="form-control form-control-sm" placeholder="Sub Total" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="taxes">Taxes</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="taxes" id="taxes" defaultValue={quotations.TAXES}
                                                            className="form-control form-control-sm" placeholder="Taxes" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="discounts">Discounts</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="discounts" id="discounts" defaultValue={quotations.DISCOUNTS}
                                                            className="form-control form-control-sm" placeholder="Discounts" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="total">Quotation Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="total" id="total" defaultValue={quotations.TOTAL}
                                                            className="form-control form-control-sm" placeholder="Total" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-8"></div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="paid_type">Paid Type</label>
                                                    <select name="PAID_TYPE"
                                                        id="paid_type"
                                                        value={invoices.PAID_TYPE}
                                                        options={invoices.PAID_TYPE}
                                                        className={((this.errorVerify("error_paid_type")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.changeValue(e);
                                                            this.calculateTotal(e);
                                                        }}>
                                                        <option value="">SELECT PAID TYPE...</option>
                                                        <option value="2">PARTIAL PAID</option>
                                                        <option value="3">TOTAL PAID</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Please choose Paid Type</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_total">Total</label>
                                                    <div className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" max={max} name="invoice_total" id="invoice_total" value={invoices.INVOICE_TOTAL}
                                                            className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Total" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.changeValue(e);
                                                                this.calculateRemaining(e);
                                                            }}
                                                            readOnly={readOnly}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Invoice Total</small>
                                                </div>
                                            </div>
                                            {
                                                invoiceRemaining ?
                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                        <div className="col-md-10"></div>
                                                        <div className="col-md-2">
                                                            <label htmlFor="invoice_remaining">Invoice Remaining</label>
                                                            <div className={((this.errorVerify("error_invoice_remaining")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" max={max} name="invoice_remaining" id="invoice_remaining" value={invoice_remaining}
                                                                    className={((this.errorVerify("error_invoice_remaining")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Remaining" aria-describedby="helpId"
                                                                    onChange={this.changeTotalValue} readOnly
                                                                />
                                                            </div>
                                                            <small id="helpId" className="invalid-feedback">Please enter Invoice Remaining</small>
                                                        </div>
                                                    </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Update Invoice</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterInvoices"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFInvoicesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFInvoicesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Invoice</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFInvoices data={invoiceData} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Download PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFInvoices data={invoiceData} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;